import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import btnstyle from "../../components/Buttons/Buttons.module.css"
import styles from "../transaction/transaction.module.css"
import brandStyles from "./Brand.module.css"
import Brandlist from "../../components/Brandlist Template/Brandlist";
import { v4 as uuidv4 } from 'uuid';
import { show, hide } from "react-functional-modal"
import styled from "styled-components"
import { Paginated } from "../../components/Paginated";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import "../../index.css";
var $ = require('jquery');
const { apiEndpoint, baseNodeapiUrl } = config;




const ImageContainer = styled.div
    `
 border: 1px solid black;
    border-radius: 27px;
  width: 83%;
  background: white;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

    
    img{
      width: 100%!important;
    height: 80%;
    object-fit: contain;
  }

  button{
    position: absolute;
    top: 4px;
    right: 11px;
    background: none;
    outline: none;
    border: none;
  }
    `

const Brand = () => {
    const decoded = tokenDecode();
    const { data } = decoded;
    const { permission: { category } } = data;
    const [listing, setListing] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [listingLoading, setListingLoading] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [brand, setBrand] = useState({
        brand_name: '',
        status: true,
        images: ''
    });
    const taxD = {
        brand_name: false
    }
    const [BrandErrorData, setBrandErrorData] = useState(taxD);
    const errorHandler = (e) => {
        if (e.target.value) {
            setBrandErrorData({ ...BrandErrorData, [e.target.name]: false });
        } else {
            setBrandErrorData({ ...BrandErrorData, [e.target.name]: true });
        }
    }
    const createBrandHandler = async () => {
        try {
            setLoading(true);
            // console.log("TAX", tax);
            if (brand?.brand_name) {
                // console.log("brand data to send-->", brand);
                const { data } = await axios({
                    url: `${apiEndpoint}/addbrand`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        "brand_name": brand.brand_name,
                        "status": brand.status,
                        "images": brand.images
                    }
                });
                // console.log("data---", data);
                if (data.status === 200) {
                    toast.success("New Brand created !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error("403 Error !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error("Please fill the required field !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const brandListHandler = async () => {
        try {
            setListing(false);
            setListingLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/getBrandList`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            // console.log("brand listing data --->", data);
            setListingLoading(false);
            if (data.status === 200) {
                setTaxData(data.data);
            }

        } catch (error) {
            setListingLoading(false);


        }
    }
    const setCrete = () => {
        setListing(true);
        setIsUpdate(false);
        setBrand({
            brand_name: '',
            status: true,
            images: ""
        })
    }
    const editRedirect = async (id) => {
        setListing(true)
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getBrands`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    "id": id
                }
            });
            // console.log("editRedirect data", data);
            if (data.status === 200) {
                setBrand({
                    brand_name: data?.data?.brand_name,
                    status: data?.data?.status,
                    images: data?.data?.images,
                    id: data?.data?.id
                })
            }
        } catch (error) {

        }
        setIsUpdate(true);
        // setListing(false);

    }

    const updateTax = async () => {
        try {
            if (brand?.brand_name) {
                setLoading(true);
                // console.log("tax", tax);
                const { data } = await axios({
                    url: `${apiEndpoint}/UpdateBrand`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        "brand_name": brand.brand_name,
                        "status": brand.status,
                        "images": brand.images,
                        id: brand.id
                    }
                });
                // console.log("data----", data);
                if (data.status === 200) {
                    toast.success("Brand Updated !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error("403 Error !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error("Please fill the required field !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const deleteTax = async (id) => {
        try {
            setLoading(true);
            // console.log("category", tax);
            const { data } = await axios({
                url: `${apiEndpoint}/deletebrand`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { id }
            });
            // console.log("data----", data);
            if (data.status === 200) {
                setTaxData(taxData.filter((item) => item.id !== id));
                toast.success("Brand Deleted !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("403 Error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }


    const productImageHandler = async (e) => {
        const files = e.target.files;


        if (!files || files.length === 0) {
            alert("Please select file(s) first!");
            return;
        }

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]); // Use the same key 'files'
        }

        try {
            const { data } = await axios.post(
                `${baseNodeapiUrl}/upload`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                        // Let browser set Content-Type
                    }
                }
            );

            if (data?.success) {
                toast.success(data.message || "Upload successful!");
                console.log("Uploaded URLs:", data.urls);

                setBrand({ ...brand, [e.target.name]: data.urls[0] })

            } else {
                toast.error("Upload failed!");
            }

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed!");
        }
    };


    const open = () => {
        show(
            <ImageContainer>
                <img src={brand.images} alt="" />
                <button onClick={() => {
                    hide("key#1")
                }}>x</button>
            </ImageContainer>,
            { key: "key#1" }
        )
    }


    const COLUMNS = [
       
        {
            Header: "Brand Name",
            Footer: "Brand Name",
            accessor: (row) => <span style={{ color: "#1F2430", fontWeight: 700, fontFamily: "'Sora', 'Inter', sans-serif" }}>{row.brand_name}</span>,
            sticky: "left",
        },
        {
            Header: "Image",
            Footer: "Image",
            accessor: (row) => (
                row.images ? (
                    <img src={row.images} alt={row.brand_name} className={brandStyles.imageThumb} />
                ) : (
                    <span className={brandStyles.noImageChip}>No Image</span>
                )
            ),
            sticky: "left",
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row) => (
                <span className={row.status === true ? brandStyles.statusBadgeActive : brandStyles.statusBadgeInactive}>
                    {row.status === true ? "Active" : "Inactive"}
                </span>
            ),
            sticky: "left",
        },

        {
            Header: "Action",
            Footer: "Action",
            accessor: (row) => {
                return (
                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                        <span className={brandStyles.iconBtn} onClick={() => editRedirect(row.id)}>
                            <EditNoteRoundedIcon style={{ color: "#4c2fb3" }} titleAccess="Update" />
                        </span>

                        <span className={brandStyles.iconBtn} onClick={() => deleteTax(row.id)}>
                            <DeleteIcon style={{ color: "#EF4444", fontSize: 20 }} titleAccess="Delete" />
                        </span>
                    </div>
                );
            },
            sticky: "left",
        },
    ];
    useEffect(() => {
        brandListHandler()
    }, [])

    // console.log(listing)
    return (
        <>
            <ThemeMaker>
                <div className={brandStyles.pageWrap}>
                    <div className={brandStyles.cardOuter}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>{listing ? "Create New Brand" : "Brand List"}</span>

                            {listing ? (
                                <button onClick={brandListHandler} className={brandStyles.primaryBtn}>
                                    Brand List
                                </button>
                            ) : (
                                <button onClick={setCrete} className={brandStyles.primaryBtn}>
                                    Create New Brand
                                </button>
                            )}
                        </div>
                        {
                            !listing ? (
                                <>  <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap} ${styles.transactionListing_desktop}`} >
                                    <div className="table-responsive">

                                        <div className="">
                                            <Paginated data={taxData} columns={COLUMNS} />
                                        </div>

                                    </div>
                                </div>
                                    <div className={`${styles.transactionListing_mobile}`} style={{ padding: "10px", background: 'white' }}>  {
                                        taxData.map((item, index) => {
                                            return <Brandlist item={item} index={index} editRedirect={editRedirect} deleteTax={deleteTax} />
                                        })
                                    }</div>
                                </>
                            ) : (
                                <div className={brandStyles.bodyArea} style={{ minHeight: "70vh" }}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className={brandStyles.field}>
                                                <label className={brandStyles.label}>
                                                    Brand name<span className={brandStyles.required}>*</span>
                                                </label>
                                                {
                                                    BrandErrorData?.brand_name ? (
                                                        <span className={brandStyles.errorText}>This field is required !</span>
                                                    ) : null
                                                }
                                                <input type="text" className={brandStyles.input} name="brand_name" placeholder="Enter Brand Name"
                                                    value={brand.brand_name}
                                                    onChange={(e) => setBrand({ ...brand, [e.target.name]: e.target.value })}
                                                    onBlur={(e) => errorHandler(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={brandStyles.field}>
                                                <label className={brandStyles.label}>
                                                    Image
                                                    {brand.images && <span
                                                        onClick={() => open()}
                                                        className={brandStyles.viewDocLink}
                                                    >
                                                        View Document
                                                    </span>}
                                                </label>
                                                <input
                                                    type="file"
                                                    className={brandStyles.fileInput}
                                                    onChange={(e) => productImageHandler(e)}
                                                    accept="image/*"
                                                    name="images"
                                                    multiple
                                                    onBlur={(e) => errorHandler(e)}
                                                    id="image"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={brandStyles.field}>
                                                <label className={brandStyles.label}>Status</label>
                                                <div className={brandStyles.statusRow}>
                                                    <input type="checkbox" checked={brand.status} name="status"
                                                        className={brandStyles.checkbox}
                                                        onChange={(e) => setBrand({ ...brand, [e.target.name]: !brand.status })}
                                                    />
                                                    <span style={{ fontSize: "13px", color: "#6B7280", fontWeight: 600 }}>
                                                        {brand.status ? "Active" : "Inactive"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            {
                                                !isUpdate && listing ? (
                                                    <button type="submit" className={brandStyles.saveBtn}
                                                        onClick={createBrandHandler}
                                                    >
                                                        Save
                                                    </button>
                                                ) : (
                                                    <button type="submit" className={brandStyles.updateBtn}
                                                        onClick={updateTax}
                                                    >
                                                        Update
                                                    </button>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </ThemeMaker>
        </>
    )
}

export default Brand;